// ----------------------------------------------------------------------------
// Component: Password Toggle
// ----------------------------------------------------------------------------
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _ = require('lodash');

var PASSWORD_TOGGLE = '.password__toggle';
var PASSWORD_INPUT = 'input.password__field';
var FORM_FIELD = '.form__field';

var PASSWORD_VISIBLE = 'password__toggle--visible';

module.exports = function() {
    $(document).on('click', PASSWORD_TOGGLE, _.bind(password.click, password));
};

var password = {
    /**
     * click: Toggle password type property
     *
     * @param {Event} e
     * @return void
     */
    click: function(e) {
        e.preventDefault();

        var $this = $(e.target);
        var $toggle = $this.closest(PASSWORD_TOGGLE);
        var $field = $this.closest(FORM_FIELD).find(PASSWORD_INPUT);

        $toggle.toggleClass(PASSWORD_VISIBLE);

        var passwordVisible = $toggle.hasClass(PASSWORD_VISIBLE);

        if(passwordVisible) {
            $field.attr('type', 'text');
        }
        else {
            $field.attr('type', 'password');
        }
    }
};
